module.exports = __webpack_public_path__ + "static/media/q_type_2.88cd09cf.png";